export default __webpack_public_path__ + "95c9b688f57dda7e0c28fcde1e1694b0.svg";